<template>
  <div>
    <div class="tg_top fl">
      <div class="tg_top_left">
        <img :src="datalist.menuImg" alt="" />
        <h1>{{ datalist.goodsName }}</h1>
        <h2>{{ datalist.goodsAdv }}</h2>
      </div>
      <div class="tg_top_right">
        <div id="qrcode"></div>
        <p>推广码</p>
      </div>
    </div>
    <div class="tg_reward">
      <div class="tg_reward_top fl">
        <div class="tg_reward_top_left">推广奖励</div>
        <div class="tg_reward_top_right fl">
          <img src="../../assets/img/warn_icom.png" alt="" />
          实际奖励以入帐为准
        </div>
      </div>
      <div class="tg_reward_con fl">
        <div class="bignumber fl">
          {{ datalist.totalProfitAmtStr }}
          <label>预计奖励</label>
        </div>
        <span>=</span>
        <div class="littlenumber fl">
          {{ datalist.goodsPriceDetailStr }}
          <label>推广收益</label>
        </div>
        <span>＋</span>
        <div class="littlenumber fl">
          {{ datalist.busRgtProfitAmtStr }}
          <label v-if="datalist.rgtLevel == 0">权益 : 无</label>
          <label v-else>权益 : V{{ datalist.rgtLevel }}</label>
        </div>
      </div>
    </div>
    <div class="tg_guize">
      <h1>结算规则</h1>
      <p>1313<!--{{ datalist.goodsDesc }}--></p>
    </div>
    <div class="tg_bottom fl">
      <span @click="doShare">立即推广</span>
      <span class="ts" @click="doTuigang">立即申请</span>
    </div>
    <template v-if="isShowShare">
      <share v-on:doCloseShare="doCloseShare"></share>
    </template>
  </div>
</template>

<script>
import share from "@/components/share.vue";
import QRCode from "qrcodejs2";
export default {
  components: {
    QRCode,
    share
  },
  data() {
    return {
      datalist: {},
      isShowShare:false,
      imgUrl:require("../../assets/img/hh.png")
    };
  },
  created() {
    //获取数据
    this.datalist = this.$route.query;
      console.log(this.datalist);
    let tit = this.$route.query.goodsName;
    if(tit != ""){
        document.title = tit;
        this.$route.meta.title = tit;
    }
    this.$nextTick(function () {
      this.qrcode();
    });
  },
  methods: {
    //点击推广
    doShare(){
      this.isShowShare = true;
    },
    //关闭推广
    doCloseShare(){
        this.isShowShare = false
    },
    //点击立即申请
    doTuigang() {
      window.location.href = this.datalist.goodsUrl;
    },
    qrcode() {
      let that = this;
      let qrcode = new QRCode("qrcode", {
        width: 66,
        height: 66, // 高度
        text: that.datalist.goodsUrl, // 二维码内容
      });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/font.scss";
.fl{
    display: flex;
}
.tg_top {
  width: 100%;
  height: 150px;
  background: url("../../assets/img/tg_topbg.png") no-repeat;
  background-size: 100% 100%;
  justify-content: space-between;
  padding: 0 20px 0 18px;
  box-sizing: border-box;
}
.tg_top_left {
  width: calc(100% - 84px);
}
.tg_top_left img {
  width: 45px;
  height: 45px;
  margin-top: 10px;
}
.tg_top_left h1 {
  font-size: 18px;
  color: #3a2100;
  line-height: 25px;
  margin-top: 6px;
  margin-bottom: 2px;
}
.tg_top_left h2 {
  font-size: 12px;
  color: #3a2100;
  line-height: 16px;
}
.tg_top_right {
  width: 84px;
  height: 99px;
  background: #fff;
  border-radius: 7px;
  margin-top: 16px;
  padding: 7px 9px 0;
  box-sizing: border-box;
  text-align: center;
  font-size: 12px;
  color: #3a2100;
}
.tg_top_right p {
  margin-top: 5px;
}
.tg_top_right img {
  width: 100%;
  height: 65px;
}
.tg_reward {
  width: 100%;
  height: 183px;
  background: url("../../assets/img/tg_bg.png") no-repeat;
  background-size: 100% 100%;
  margin-top: -33px;
  padding: 0 15px;
  box-sizing: border-box;
}
.tg_reward_top {
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 12px;
  padding-top: 25px;
}
.tg_reward_top_left {
  width: 97px;
  height: 26px;
  background: url("../../assets/img/tg_titbg.png") no-repeat;
  background-size: 100% 100%;
  color: #e8d3a3;
  line-height: 26px;
  padding-left: 28px;
  box-sizing: border-box;
}
.tg_reward_top_right {
  color: #c4883c;
  margin-right: 15px;
  align-items: center;
}
.tg_reward_top_right img {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}
.tg_reward_con {
  color: #a36616;
  font-size: 18px;
  line-height: 42px;
  margin-left: 15px;
  margin-top: 18px;
  font-family: "DIN";
}
.tg_reward_con span {
  margin: 0 8px;
}
.bignumber {
  position: relative;
  font-weight: bold;
  min-width: 85px;
  justify-content: center;
}
.bignumber em {
  font-family: "PingFang SC";
}
.littlenumber {
  position: relative;
  justify-content: center;
  min-width: 85px;
}
.littlenumber em {
  font-size: 16px;
}
.bignumber label,
.littlenumber label {
  position: absolute;
  font-size: 12px;
  width: 82px;
  left: 50%;
  top: 30px;
  margin-left: -40px;
  text-align: center;
  font-family: "PingFang SC";
  font-weight: normal;
}
.tg_guize {
  color: #666;
  font-size: 12px;
  line-height: 22px;
  margin: 5px 15px 0;
}
.tg_guize h1 {
  font-size: 16px;
  line-height: 29px;
  margin-bottom: 12px;
  color: #1c162e;
}
.tg_bottom {
  width: 100%;
  position: fixed;
  height: 44px;
  bottom: 20px;
  padding: 0 15px;
  box-sizing: border-box;
  justify-content: space-between;
}
.tg_bottom span {
  width: calc((100% - 15px) / 2);
  height: 44px;
  line-height: 44px;
  background: #fffdf5;
  border: 1px solid #EF3C35;
  border-radius: 22px;
  color: #EF3C35;
  font-size: 16px;
  text-align: center;
}
.tg_bottom span.ts {
  background: #EF3C35;
  border-color: #EF3C35;
  color: #fff;
}
@media screen and ( max-width:370px ) {
    .tg_reward{
      height: 160px;
    }
    .tg_reward_top{
      padding-top: 20px;
    }
    .tg_reward_con {
      font-size: 16px;
      margin-left: 10px;
      margin-top: 10px;
    }
    .tg_reward_con span {
      margin: 0 5px;
    }
    .bignumber {
      min-width: 65px;
    }
    .littlenumber {
      min-width: 65px;
    }
    .littlenumber em {
      font-size: 14px;
    }
}

@media screen and ( min-width:400px ) {
  .tg_reward{
    height: 190px;
  }
}
</style>